import React, { useEffect, useState } from 'react'
import Breadcrumb from '../Component/BradeCrum'
import Product from '../Component/Product'
import HeaderMobile from '../Component/MobileHader'
import ProductBCrumb from '../Component/ProductBCrumb'
import { Hourglass } from 'react-loader-spinner'


const allProdutUrl = {name : "Product Categories", url : "/All_Products"}

const ProductListing = () => {
  const [heading, setHeading] = useState("")
    const [loading, setLoading] = useState(true);
  
    useEffect(() => {
      // Simulate a loading state
      setLoading(true); // Set loading to true initially
      const timer = setTimeout(() => {
        setLoading(false); // After 2 seconds, stop loading
      }, 2000);
  
      window.scrollTo(0, 0);
  
      // Cleanup timer
      return () => clearTimeout(timer);
    }, []);
  return (
    <React.Fragment>
        {loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100vh",
                }}
              >
                <Hourglass
                  height={80}
                  width={80}
                  color="#01458e"
                  ariaLabel="loading-content"
                />
              </div>
            ) : (
      <div>
      <HeaderMobile/>
     {/* <Breadcrumb heading={heading} midTitle={allProdutUrl} bTitle={heading} /> */}
     <ProductBCrumb heading={heading} allProductLink={allProdutUrl} />
     <Product setHeading={setHeading} />
     </div>
     )}
    </React.Fragment>
  )
}

export default ProductListing